import React from 'react';
import './Footer.css';

const Footer = () => {
   return (
    <div className="footer">   
        <h5> Made with Passion for 💰 by <span className="nameLink"><a href="https://www.alexyang.ca">Alexander G. Yang</a></span> during 2020 Pandemic Era</h5>
    </div>
   ) 
} 

export default Footer;